import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppRelease, CreateDesktopAppRelease } from '../models/inModels/app-release.model';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';

@Injectable()
export class AppReleaseService {
  private route = '/api/assets/app/release';
  constructor(private http: HttpClient, 
              private auth: AuthenticationService, 
              private logging: LoggingService) {}

  search(event: LazyLoadEvent): Promise<any> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/search`, JSON.stringify(event), { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
  }

  delete(id: number): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

  uploadDesktopRelease(model: CreateDesktopAppRelease): Promise<any> {
    return  this.http.post(`${this.auth.apiUrl}${this.route}/create`, JSON.stringify(model), { headers: this.auth.header })
    .toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));;
  }

  getRelease(id: number) {
  return this.http.get<AppRelease>(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header });
}

 updateRelease(id: number, release: AppRelease): Observable<any> {
    return this.http.put(`${this.auth.apiUrl}${this.route}/update/${id}`, release, { headers: this.auth.header });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app-release.service.ts